import { cache } from "react";
import {
  defaultShouldDehydrateQuery,
  isServer,
  QueryClient,
} from "@tanstack/react-query";

// This function should now be used ONLY in server components for prefetching
// Client components should use useQueryClient() hook instead

function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000,
        // Prevent automatic background refetching which can cause route revalidation
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        retry: 1,
      },
      dehydrate: {
        // include pending queries in dehydration
        shouldDehydrateQuery: (query) =>
          defaultShouldDehydrateQuery(query) ||
          query.state.status === "pending",
      },
    },
  });
}

// Server: React.cache() ensures all server components within the same request
// share a single QueryClient instance. This deduplicates prefetch calls across
// concurrent Suspense boundaries (e.g. desktop + mobile layouts rendering the same data).
// The cache is automatically discarded when the request completes.
const getServerQueryClient = cache(makeQueryClient);

let browserQueryClient: QueryClient | undefined = undefined;

export function getQueryClient() {
  if (isServer) {
    return getServerQueryClient();
  } else {
    // ⚠️ WARNING: Only for initial hydration in the RQProvider
    // Don't use this in other client components - use useQueryClient() hook instead
    if (!browserQueryClient) browserQueryClient = makeQueryClient();
    return browserQueryClient;
  }
}
